module.exports = __webpack_public_path__ + "img/unclefarmer_man.48385c43.jpg";